const LK_Info = ({ color, width, height }) => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 116.99 116.99"
      fill={color}
      width={width}
      height={height}
    >
      {/*  <defs>
                <style>
                .cls-1 {
                    fill: #005c8b;
                }
                </style>
            </defs> 
            */}
      <path
        class="cls-1"
        d="M58.49,4.33c29.86,0,54.16,24.3,54.16,54.16s-24.3,54.16-54.16,54.16S4.33,88.36,4.33,58.49,28.63,4.33,58.49,4.33M58.49,0C26.19,0,0,26.19,0,58.49s26.19,58.49,58.49,58.49,58.49-26.19,58.49-58.49S90.8,0,58.49,0h0Z"
      />
      <path
        class="cls-1"
        d="M60.66,37.55v63.55h-1.44c-1.59,0-2.89-1.3-2.89-2.89v-60.66h4.33M64.99,33.22h-13v64.99c0,3.99,3.23,7.22,7.22,7.22h5.78V33.22h0Z"
      />
      <path
        class="cls-1"
        d="M58.49,15.92c1.97,0,3.57,1.6,3.57,3.57s-1.6,3.57-3.57,3.57-3.57-1.6-3.57-3.57,1.6-3.57,3.57-3.57M58.49,11.59c-4.37,0-7.91,3.54-7.91,7.91s3.54,7.91,7.91,7.91,7.91-3.54,7.91-7.91-3.54-7.91-7.91-7.91h0Z"
      />
    </svg>
  );
};

export default LK_Info;
